import N8nTabs from './Tabs.vue';

export default N8nTabs;
